import { CommonModule, NgClass, NgSwitch } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'u-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UButtonComponent {
  readonly type = input.required<'button' | 'link'>();
  /**
   * Used for external redirection when type is **link**.
   * For type **button** is used for display with no other purpose.
   */
  readonly href = input<string | null>();
  /** For type **link**. Used for internal navigation */
  readonly routerLink = input<string | null>();
  /** For type **link**. Used for external navigation */
  readonly isExternalLink = input<boolean | null>();

  readonly ngClass = input<
    | string
    | string[]
    | Set<string>
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [klass: string]: any;
      }
  >();
  readonly onClick = input<(event: MouseEvent, ...args: unknown[]) => void>();

  readonly isActive = input<boolean | null>();
  /** Used to attach to the attribute data-translate */
  readonly attrTranslate = input<string | null>();

  clickButton(e: MouseEvent, callback: (event: MouseEvent, ...args: unknown[]) => void) {
    e.preventDefault();
    if (callback) {
      callback(e);
    }
  }

  clickLink(e: MouseEvent, callback: (event: MouseEvent, ...args: unknown[]) => void) {
    if (callback) {
      callback(e);
    }
  }
}
